import React from 'react';
import { Navigate } from 'react-router-dom';
import { Server } from '../../server/server';
import { BsFillSkipBackwardFill, BsFillSkipEndFill, BsFillSkipForwardFill, BsFillSkipStartFill } from 'react-icons/bs';
import AlertModal from '../modals/AlertModal';
import BadWords from '../util/badWords';
import PageEnvelope from '../elements/PageEnvelope';
import PageHeader from '../elements/PageHeader';
import ContentPanel from '../elements/ContentPanel';
import './SitePage.css'
import './ForumTopicPage.css'

interface ForumTopicPageState {
  loading: boolean;
  posts: any[];
  forum: any;
  topic: any;
  alert: string;
  navigate: string;
  page: string;
}

class ForumTopicPage extends React.Component<{}, ForumTopicPageState> {
  postsPerPage: number;

  constructor(props: {}) {
    super(props);
    this.state = {
      loading: false,
      posts: [],
      topic: null,
      forum: null,
      alert: '',
      navigate: '',
      page: 'first'
    };

    this.postsPerPage = 10;
  }

  componentDidMount() {
    this.load();
  }

  getForumId() {
    let i1 = window.location.pathname.lastIndexOf('/');
    let i2 = window.location.pathname.lastIndexOf('/', i1-1);
    return window.location.pathname.substring(i1, i2+1);
  }

  getTopicId() {
    let i = window.location.pathname.lastIndexOf('/');
    return window.location.pathname.substring(i+1);
  }

  getProfilesInPosts(posts:any[]) {
    let profiles = [];
    for (let i = 0; i < posts.length; i++) {
      let post = posts[i];
      if(profiles.indexOf(post.author) == -1)
        profiles.push(post.author);
    }
    return profiles;
  }

  async load() {
    this.setState({loading: true});

    let response:any = await Server.forums.getForum(this.getForumId());
    if(!response.success) {
      this.setState({loading: false, alert: response.message});
      return false;
    }

    let forum = response.forum;

    response = await Server.forums.getTopic(this.getForumId(), this.getTopicId());
    if(!response.success) {
      this.setState({loading: false, alert: response.message});
      return false;
    }

    let topic = response.topic;
    topic.title = BadWords.clean(topic.title);

    this.setState({forum, topic});

    let page = 'first';
    let storedParams = window.sessionStorage.getItem('ForumTopicPageParams');
    if(storedParams)
      page = storedParams;
    window.sessionStorage.removeItem('ForumTopicPageParams');

    await this.loadPosts(page);
  }

  async loadPosts(page:string) {
    this.setState({loading: true});

    let params:any = {limit: this.postsPerPage};

    if(page == 'next') {
      let post = this.state.posts[this.state.posts.length-1];
      params.after = {date: post.date, author: post.author};
    }
    else if(page == 'previous') {
      let post = this.state.posts[0];
      params.sort = 'descending';
      params.before = {date: post.date, author: post.author};
    }
    else if(page == 'last') {
      params.sort = 'descending';
    }
    else if(page == 'restore') {
      let storedParams = window.sessionStorage.getItem('ForumTopicPageGetPosts');
      if(storedParams) 
        params = JSON.parse(storedParams);
    }

    window.sessionStorage.setItem('ForumTopicPageGetPosts', JSON.stringify(params));

    let response = await Server.forums.getPosts(this.getForumId(), this.getTopicId(), params);

    if(!response.success) {
      this.setState({loading: false, alert: response.message});
      return;
    }

    if(response.posts.length == 0) {
      this.setState({loading: false, page: page == 'next' ? 'last' : 'first'});
      return;
    }

    if(response.posts.length < this.postsPerPage && page == 'previous') {
      setTimeout(() => {
        this.loadPosts('first');
      }, 100);
      return;
    }

    let profiles = this.getProfilesInPosts(response.posts);
    await Server.public.loadProfiles(profiles);

    let posts = [];
    if(params.sort == 'descending') {
      for(let i = response.posts.length-1; i >= 0; i--)
        posts.push(response.posts[i]);
    }
    else  
      posts = response.posts;

    if(posts.length < this.postsPerPage && page == 'next')
      page = 'last';

    if(posts.length < this.postsPerPage && page == 'first')
      page = 'none';

    this.setState({posts, page, loading: false});
  }

  onEditPost(postDate:string) {
    let forumId = this.getForumId();
    let topicId = this.getTopicId();
    let d = new Date(postDate);
    let postId = d.getTime().toString();
    let url = `/forum/${forumId}/${topicId}/${postId}/edit`;
    this.setState({navigate: url})
  }

  onEditTopic() {
    this.setState({navigate: `/forum/${this.getForumId()}/${this.getTopicId()}/edit`})
  }

  onReply() {
    if(!Server.account.isLoggedIn()) {
      this.setState({alert: 'Please login to post a reply.'});
      return;
    }
    
    this.setState({navigate: `/forum/${this.getForumId()}/${this.getTopicId()}/new`});
  }

  onNextPage() {
    this.loadPosts('next');
  }

  onPreviousPage() {
    this.loadPosts('previous');
  }

  onFirstPost() {
    this.loadPosts('first');
  }

  onLastPage() {
    this.loadPosts('last');
  }

  renderReplies() {
    let divs = [];

    for (let i = 1; i < this.state.posts.length; i++) {
      let post = this.state.posts[i];
      let title = (i == 0) ? this.state.topic.title : '';
      let action = post.author == Server.user.getId() && !this.state.topic.archived ? 'edit' : '';
      if(this.state.forum && this.state.forum.archived)
        action = '';

      divs.push(
        <ContentPanel 
          key={i}
          author={post.author}
          date={post.date}
          content={post.content}
          title={title}
          // reply={true}
          action={action}
          onAction={()=>this.onEditPost(post.date)}
        />
      );
    }

    return divs;
  }

  renderPageControls() {
    return (
      <div>
        <div className="site-page-row" style={{columnGap: '5px'}}>
          {this.state.page != 'first' && this.state.page != 'none' &&
            <button className="forum-topic-page-button" onClick={()=>this.onFirstPost()}><BsFillSkipBackwardFill/></button>
          }
          {this.state.page != 'first' && this.state.page != 'none' &&
            <button className="forum-topic-page-button" onClick={()=>this.onPreviousPage()}><BsFillSkipStartFill/></button>
          }
          {this.state.page != 'last' && this.state.page != 'none' &&
            <button className="forum-topic-page-button" onClick={()=>this.onNextPage()}><BsFillSkipEndFill/></button>
          }
          {this.state.page != 'last' && this.state.page != 'none' &&
            <button className="forum-topic-page-button" onClick={()=>this.onLastPage()}><BsFillSkipForwardFill/></button>
          }
        </div>
      </div>
    );
  }

  renderLoading() {
    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          <PageHeader text="Loading..." navigate="/forums" />
        </PageEnvelope>
      </div>
    )
  }

  render() {
    if(this.state.navigate != '') 
      return <Navigate to={this.state.navigate} state={{from:'forum-topic'}} />;

    if(this.state.loading || !this.state.topic)
      return this.renderLoading();

    let action = this.state.topic.author == Server.user.getId() ? 'edit' : '';
    if(this.state.forum && this.state.forum.archived)
      action = '';

    let blockReply = (this.state.topic && this.state.topic.archived) || (this.state.forum && this.state.forum.archived);

    return (
      <div className="site-page">
        <PageEnvelope width="600px">
          <div className="site-page-column">

            <PageHeader text="View Topic" navigate={'/forum/' + this.getForumId()} force={true} />

            {this.state.forum && this.state.forum.archived && 
              <div className="site-page-header" style={{justifyContent: 'center', backgroundColor: 'var(--notification-background-color)'}}>
                This forum has been archived.
              </div>
            }

            {this.state.topic && this.state.topic.archived && 
              <div className="site-page-header" style={{justifyContent: 'center', backgroundColor: 'var(--notification-background-color)'}}>
                This topic has been archived.
              </div>
            }

            <ContentPanel 
              author={this.state.posts[0].author}
              date={this.state.posts[0].date}
              content={this.state.posts[0].content}
              title={this.state.topic.title}
              action={action}
              onAction={()=>this.onEditTopic()}
            />

            {!this.state.loading && this.state.posts.length > 1 &&
              <div className="site-page-column">
                {this.renderReplies()}
              </div>
            }

            {!this.state.loading &&
              <div className="site-page-row" style={{justifyContent: 'space-between'}}>
                {this.renderPageControls()}
                <button onClick={()=>this.onReply()} disabled={blockReply}>Reply</button>
              </div>
            }
          </div>
        </PageEnvelope>

        <AlertModal message={this.state.alert} button="OK" onClose={()=>this.setState({alert: ''})}/>
      </div>
    );
  }
}

export default ForumTopicPage;